import useFingerPay from '@hooks/order/useFingerPay';
import useNicePay from '@hooks/order/useNicePay';
import useProject from '@hooks/useProject';
import { PrepaidCardOrderResponse } from '@models/prepaidCard';

function usePrepaidCardPayment() {
    const project = useProject();
    const openNicePay = useNicePay();
    const openFingerPay = useFingerPay();

    return (response: PrepaidCardOrderResponse, paymentAmount: number, itemName: string) => {
        const {
            checkoutUrl, orderNo, mallId, requestedAt, hashString, returnUrl,
        } = response;
        if (checkoutUrl) {
            window.location.href = checkoutUrl;
            return;
        }
        if (!orderNo || !mallId || !requestedAt || !hashString || !returnUrl) {
            throw new Error('Invalid prepaid card payment response');
        }
        const params = {
            orderNo, mallId, requestedAt, hashString, paymentAmount, itemName, returnUri: returnUrl,
        };
        if (project?.pgVendor === 'NICEPAY') {
            openNicePay(params);
        } else if (project?.pgVendor === 'FINGERPAY') {
            openFingerPay({ ...params, paymentMethod: 'CREDIT_CARD' });
        } else {
            throw new Error('Unsupported prepaid card payment provider');
        }
    };
}

export default usePrepaidCardPayment;
